import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction } from '../models/api-model';
import { apiAction } from './base-api';


export const getMyCpgPodInfo = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.myCpgPod}/`,
		onSuccess,
		onFailure,
	});
};

export const getMyCpgPodsByGuid = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.myCpgPod}/pods/${guid}.json`,
		onSuccess,
		onFailure,
	});
};

export const getPensionBillingInfoByGuid = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.myCpgPod}/person_pension_account_summaries/${guid}`,
		onSuccess,
		onFailure,
	});
};

export const getGhlBillingInfoByGuid = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.myCpgPod}/person_ghl_billing_account_summaries/${guid}`,
		onSuccess,
		onFailure,
	});
};
